import React from 'react';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import Segment from 'semantic-ui-react/dist/commonjs/elements/Segment';
import Image from 'semantic-ui-react/dist/commonjs/elements/Image';
import { ADDRESS_POA_DOCUMENT, SCREEN_NAME_PHOTO_UPLOAD } from '../../utils/constants';
import CommonButton from '../common-button/CommonButton';
import { SAMPLE_PHOTO_EU_ICON, SAMPLE_PHOTO_SG_ICON } from '@Images';

interface IUploadDocsFields {
  fieldscustom: any;
  noPadClass: string;
  sectionHead: string;
  isEmbeddedSection: any;
  getSectionTitle: (type: string) => any;
  currentScreen: any;
  fieldscustomTemplate: (type: string) => any;
  skipScreen: () => void;
  isEverificationSuccessful: boolean;
  country_code: string;
  isShowSamplePhotograph: boolean;
  noButtonNeeded: boolean;
  userAddress: any;
}

export const UploadDocsFields: React.FC<IUploadDocsFields> = (props) => {
  const {
    fieldscustom,
    noPadClass,
    sectionHead,
    isEmbeddedSection,
    getSectionTitle,
    currentScreen,
    fieldscustomTemplate,
    skipScreen,
    isEverificationSuccessful,
    country_code,
    isShowSamplePhotograph,
    noButtonNeeded
  } = props;
  const SELFI_IMG = ['SG', 'HK'];
  return (
    <Segment raised className={`nobor noshadow ${noPadClass}`}>
      <Grid
        container
        className={`upload-documents-fold-1-page form-grid right-to-left-anime ${noPadClass}`}
        centered
      >
        {fieldscustom &&
          Object.keys(fieldscustom).map((type, index) => {
            return (
              fieldscustom[type] &&
              fieldscustom[type].length > 0 && (
                <Grid.Row key={index} className="upload-doc-row row">
                  {sectionHead || !isEmbeddedSection ? (
                    <Grid.Column width={16}>{getSectionTitle(type)}</Grid.Column>
                  ) : null}
                  {fieldscustom[type][0]?.document_code === ADDRESS_POA_DOCUMENT && (
                    <div className=" sixteen wide column user-address-heading">
                      Address you provided during onboarding
                      <hr className="horizontal-line"></hr>
                      <div className="user-address">{props.userAddress?.formatted_address}</div>
                    </div>
                  )}
                  {currentScreen === SCREEN_NAME_PHOTO_UPLOAD ? (
                    [
                      <Grid.Column
                        key={index + 'grid-relative upload-doc-section-grid'}
                        className={`${noPadClass}`}
                        width={isShowSamplePhotograph ? 12 : 16}
                      >
                        <Grid className={`grid-relative upload-doc-section-grid ${noPadClass}`}>
                          {fieldscustomTemplate(type)}
                        </Grid>
                      </Grid.Column>,
                      <Grid.Column key={index + 'sample-img'} width={4} className={`${noPadClass}`}>
                        {isShowSamplePhotograph && (
                          <div className="sample-img">
                            <Image
                              id="perosnal-image"
                              className="upload-img"
                              src={
                                SELFI_IMG.includes(country_code)
                                  ? SAMPLE_PHOTO_SG_ICON
                                  : SAMPLE_PHOTO_EU_ICON
                              }
                              alt="personal photo"
                            />
                            <div className="sample">Sample Photograph</div>
                          </div>
                        )}
                      </Grid.Column>
                    ]
                  ) : (
                    <Grid.Column width={16} className={`${noPadClass}`}>
                      <Grid className="grid-relative upload-doc-section-grid">
                        {fieldscustomTemplate(type)}
                      </Grid>
                    </Grid.Column>
                  )}
                  {country_code === 'IN' && type === 'POA' && (
                    <Grid.Column width={16} className={`${noPadClass}`}>
                      <Grid className="grid-relative upload-doc-section-grid">
                        <div className="poa_notes">
                          If address given on personal info is not as per the uploaded document, we
                          will update it as per the proof of address in our records.
                        </div>
                      </Grid>
                    </Grid.Column>
                  )}
                </Grid.Row>
              )
            );
          })}
        {!noButtonNeeded &&
          (!isEmbeddedSection ? (
            fieldscustom.disableForm ? (
              <Grid.Row>
                <Grid.Column>
                  <CommonButton
                    text="Next"
                    id="submit"
                    type="button"
                    className="save-continue-button-new"
                    onClick={skipScreen}
                  />
                </Grid.Column>
              </Grid.Row>
            ) : (
              <Grid.Row>
                <Grid.Column>
                  <CommonButton
                    className="save-continue-button-new"
                    width={250}
                    height={42}
                    disabled={!isEverificationSuccessful}
                    id="submit"
                    text="Save and continue"
                  />
                </Grid.Column>
              </Grid.Row>
            )
          ) : null)}
      </Grid>
    </Segment>
  );
};
